// K2-3095 (2.6.0 review VSE-P1): `$cookies.set('ct', null)` stored the string "null", which the
// client and SSR then sent as a cart token. A missing token now removes the cookie, and readers
// treat an empty, "null" or "undefined" cookie (already in customers' browsers) as no token.

export const CART_TOKEN_COOKIE = 'ct'
// localforage's raw key for $db.cartsCollection 'current-cart-token', which the theme reads directly
export const CART_TOKEN_STORAGE_KEY = 'shop/carts/current-cart-token'

export function cartTokenFromCookie (value: any): string | null {
  if (value === null || value === undefined) {
    return null
  }
  const token = String(value).trim()
  return token === '' || token === 'null' || token === 'undefined' ? null : token
}

/** The cart token under the raw localStorage key; a stored "null" (from an older disconnect) is none. */
export function storedCartToken (storage: { getItem: (key: string) => any } = localStorage): string | null {
  return cartTokenFromCookie(storage.getItem(CART_TOKEN_STORAGE_KEY))
}

export function writeCartTokenCookie (cookies: { set: Function, remove: Function }, token: any): void {
  const value = cartTokenFromCookie(token)
  if (value === null) {
    cookies.remove(CART_TOKEN_COOKIE)
  } else {
    cookies.set(CART_TOKEN_COOKIE, value)
  }
}
